module.exports = __webpack_public_path__ + "img/email-header-recognition@2x.2a0a3a08.png";